module.exports = __webpack_public_path__ + "static/ceremony-preroll-4cdc6e351dfa62a5c5d3dcb440605c19.jpg";